import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ToolAccessGuard } from './guards/tool-access.guard';
import { AuthGuard } from '@auth0/auth0-angular';

const routes: Routes = [
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.component').then((m) => m.ProfileComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'motortwin',
    loadComponent: () => import('./pages/motortwin-landing/motortwin-landing.component').then((m) => m.MotortwinLandingComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'jobs',
    loadComponent: () => import('./pages/jobs/jobs.component').then((m) => m.JobsComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'jobs/:fetch_type',
    loadComponent: () => import('./pages/jobs/jobs.component').then((m) => m.JobsComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'job/:id',
    loadComponent: () => import('./pages/job/job.component').then((m) => m.JobComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'logs',
    loadComponent: () => import('./pages/logs/logs.component').then((m) => m.LogsComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'log/:id',
    loadComponent: () => import('./pages/log/log.component').then((m) => m.LogComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'materials',
    loadComponent: () => import('./pages/materials/materials.component').then((m) => m.MaterialsComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'material/:id',
    loadComponent: () => import('./pages/material/material.component').then((m) => m.MaterialComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'messages',
    loadComponent: () => import('./pages/messages/messages.component').then((m) => m.MessagesComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'geometry/:id',
    loadComponent: () => import('./pages/geometry/geometry.component').then((m) => m.GeometryComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'users',
    loadComponent: () => import('./pages/users/users.component').then((m) => m.UsersComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'motortwin' },
  },
  {
    path: 'user/:id',
    loadComponent: () => import('./pages/user/user.component').then((m) => m.UserComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'organisations',
    loadComponent: () => import('./pages/organisations/organisations.component').then((m) => m.OrganisationsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'org/:id',
    loadComponent: () => import('./pages/org/org.component').then((m) => m.OrgComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'clusters',
    loadComponent: () => import('./pages/clusters/clusters.component').then((m) => m.ClustersComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'fmeda',
    loadComponent: () => import('./pages/fmeda-landing/fmeda-landing.component').then((m) => m.FmedaLandingComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'fmeda' },
  },
  {
    path: 'projects',
    loadComponent: () => import('./pages/projects/projects.component').then((m) => m.ProjectsComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'fmeda' },
  },
  {
    path: 'fmeda-workspace',
    loadComponent: () => import('./pages/fmeda/fmeda.component').then((m) => m.FmedaComponent),
    canActivate: [AuthGuard, ToolAccessGuard],
    data: { requiredApp: 'fmeda' },
  },
  {
    path: 'fmeda-pdf',
    // This data-free shell receives PDFs from its authenticated opener, not from the API.
    loadComponent: () => import('./pages/fmeda/fmeda-pdf-popout.component').then((m) => m.FmedaPdfPopoutComponent),
  },
  {
    path: 'error',
    loadComponent: () => import('./pages/error/error.component').then((m) => m.ErrorComponent),
  },
  {
    path: '',
    loadComponent: () => import('./pages/app-selection/app-selection.component').then((m) => m.AppSelectionComponent),
    canActivate: [AuthGuard],
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
